import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "Dialogue",
  icon: "💬",
  templates: [
    {
      title: "Modèle d'Interview Podcast",
      content: `Écrivez une interview de style podcast entre deux interlocuteurs.
- L'interlocuteur 1 est l'animateur : [un journaliste tech curieux et enthousiaste].
- L'interlocuteur 2 est l'invité : [un chercheur en IA renommé qui vient de publier un article révolutionnaire].
- Le sujet de discussion est [l'avenir de la collaboration humain-IA dans les domaines créatifs].
- Le ton doit être [conversationnel, perspicace et parfois humoristique].
- Incluez des échanges naturels avec des questions de suivi et des anecdotes.

Formatez chaque ligne comme "Speaker 1:" ou "Speaker 2:" suivi de leur dialogue.`,
      mode: 'multi'
    },
    {
      title: "Modèle de Débat",
      content: `Écrivez un débat structuré entre deux interlocuteurs aux points de vue opposés.
- L'interlocuteur 1 argumente [en faveur du télétravail comme norme permanente].
- L'interlocuteur 2 argumente [que la collaboration au bureau est essentielle pour l'innovation].
- Les deux interlocuteurs doivent présenter [des arguments bien raisonnés avec des exemples concrets].
- Le ton doit être [respectueux mais passionné].
- Chaque interlocuteur doit répondre directement aux points de l'autre.

Formatez chaque ligne comme "Speaker 1:" ou "Speaker 2:" suivi de leur dialogue.`,
      mode: 'multi'
    },
    {
      title: "Modèle de Dialogue pour l'Apprentissage des Langues",
      content: `Écrivez un dialogue conversationnel entre deux interlocuteurs pour les apprenants en langues.
- Le scénario est [commander de la nourriture dans un marché de rue animé].
- L'interlocuteur 1 est [un vendeur local sympathique qui recommande ses meilleurs plats].
- L'interlocuteur 2 est [un voyageur qui goûte la cuisine locale pour la première fois].
- Incluez [des hésitations naturelles, des formules de politesse et du contexte culturel].
- Le dialogue doit sembler authentique et aider les apprenants avec [des phrases conversationnelles du quotidien].

Formatez chaque ligne comme "Speaker 1:" ou "Speaker 2:" suivi de leur dialogue.`,
      mode: 'multi'
    }
  ]
};
